import React, { useCallback } from 'react';
import { Pressable } from 'react-native';

import PersonSVG from '~/assets/svgs/person.svg';
import colors from '~/assets/themes/colors';
import Text from '../Text';
import useAppNavigation from '~/hooks/useAppNavigation';
import type { InsuranceType } from '~/@types/insurance';
import { AppOriginType, MarisaAppUtils } from '~/utils/MarisaAppUtils';

interface Props {
  type: InsuranceType;
  beforeNavigate: () => void;
}

const ContractSellerButton: React.FC<Props> = ({ type, beforeNavigate }) => {
  const { navigate } = useAppNavigation();

  const handlePress = useCallback(() => {
    beforeNavigate();
    navigate('MarisaServicos_ContractSellerInfo', { type });
  }, [beforeNavigate, navigate, type]);

  if (
    !MarisaAppUtils.isTotem() &&
    MarisaAppUtils.origin !== AppOriginType.CREDIT
  )
    return null;

  return (
    <Pressable
      className="mt-8 shadow bg-light-100 rounded-md p-4 flex-row items-center"
      onPress={handlePress}
    >
      <PersonSVG width={24} height={24} color={colors.gray[400]} />

      <Text className="text-gray-400 text-xs ml-2">
        Digite o CPF do vendedor{' '}
      </Text>
    </Pressable>
  );
};

export default ContractSellerButton;
